import { Box } from '@mui/material'
import ListCreateTab from 'components/ListCreateTab'
import React from 'react'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationAddIcon from '@mui/icons-material/NotificationAddOutlined';
import AlertAllocationList from './AlertAllocationList';
import AlertAllocationCreation from './AlertAllocationCreation';

const AlertManagement = () => {
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Alert"
        viewIcon={<NotificationsNoneIcon />}
        createIcon={<NotificationAddIcon />}
        createChildren={<AlertAllocationCreation/>}
        listChildren={<AlertAllocationList />}
      />
    </Box>
  )
}

export default AlertManagement